export const activeStatusOptions = [
    { value: "true", label: "Active" },
    { value: "false", label: "Inactive" },
];
export const usersInRoleOptions = [
    { value: "0-10", label: "0-10" },
    { value: "11-20", label: "11-20" },
    { value: "21+", label: "21+" },
];
// Module options for permissions
export const moduleOptions = [
    { value: "Dashboard", label: "Dashboard" },
    { value: "Nodes", label: "Nodes" },
    { value: "Alarms", label: "Alarms" },
    { value: "Insights", label: "Insights" },
    { value: "Reports", label: "Reports" },
    { value: "Users", label: "Users" },
    { value: "AccessPoints", label: "Access Points" },
    { value: "Roles", label: "Roles" },
];
export const allPermissions = [
    { key: "Dashboard", value: "View" },
    { key: "Nodes", value: "View" },
    { key: "Nodes", value: "Create" },
    { key: "Nodes", value: "Edit" },
    { key: "Nodes", value: "HardwareSettings" },
    { key: "Nodes", value: "Delete" },
    { key: "Alarms", value: "View" },
    { key: "Alarms", value: "Acknowledge" },
    { key: "Alarms", value: "Clear" },
    { key: "Insights", value: "View" },
    { key: "Reports", value: "View" },
    { key: "Reports", value: "Generate" },
    { key: "Reports", value: "Export" },
    { key: "Users", value: "View" },
    { key: "Users", value: "Create" },
    { key: "Users", value: "Edit" },
    { key: "Users", value: "Delete" },
    { key: "AccessPoints", value: "View" },
    { key: "AccessPoints", value: "Create" },
    { key: "AccessPoints", value: "Edit" },
    { key: "AccessPoints", value: "ServerSettings" },
    { key: "AccessPoints", value: "Delete" },
    { key: "Roles", value: "View" },
    { key: "Roles", value: "Create" },
    { key: "Roles", value: "Edit" },
    { key: "Roles", value: "Delete" },
];
